<template>
  <v-main>
    <UkplMenu
      :current-user="currentUser"
      :is-admin="isAdmin"
      :log-out="logOut"
      menu-class="home-navigation"
    />

    <v-container
      class="ukpl-login-card-container"
      fluid
    >
      <v-row
        align="center"
        justify="center"
        class="margin20"
      >
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <v-card class="ukpl-login-card">
            <v-window v-model="step">
              <v-window-item :value="1">
                <v-row>
                  <v-col
                    cols="12"
                    md=""
                  >
                    <v-form
                      ref="signinform"
                      v-model="signinvalid"
                      class="ukpl-login-card-signin"
                      @submit.prevent="signin"
                    >
                      <v-card-text>
                        <div class="ukpl-login-card-signin-logo-wrap">
                          <v-img
                            src="@/assets/ECPL.png"
                            class="ukpl-login-card-signin-logo"
                          />
                        </div>

                        <h4 class="text-center mlt-4 mt-3">
                          Enter your login details below to sign in
                        </h4>
                        <v-text-field
                          v-model="loginuser.username"
                          :rules="mandatoryRules"
                          label="Username or Email Address"
                          name="username"
                          prepend-icon="person"
                          type="text"
                          color="blue accent-3"
                          class="ukpl-login-card-signin-text-field"
                        />
                        <v-text-field
                          id="password"
                          v-model="loginuser.password"
                          :rules="mandatoryRules"
                          label="Password"
                          name="password"
                          prepend-icon="lock"
                          type="password"
                          color="blue accent-3"
                          class="ukpl-login-card-signin-text-field"
                        />
                        <v-alert
                          type="error"
                          transition="scale-transition"
                          :value="loginfail"
                        >
                          Username or Password Invalid.
                        </v-alert>
                      </v-card-text>
                      <div class="text-center mb-3">
                        <v-btn
                          class="blue-btn-primary"
                          rounded
                          color="blue accent-3"
                          dark
                          type="submit"
                        >
                          Sign In
                        </v-btn>
                      </div>
                      <div class="spacer20" />
                    </v-form>
                  </v-col>
                  <!-- Registration section removed -->
                </v-row>
              </v-window-item>
              <!-- Registration window removed -->
              <v-window-item :value="3">
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-card-text class="mt-4">
                      <v-img src="@/assets/ECPL.png" />
                      <h4 class="text-center mlt-4 mt-3">
                        Enter your Email address to reset your password
                      </h4>
                      <v-form
                        ref="resetpasswordform"
                        v-model="resetpassword"
                      >
                        <v-text-field
                          v-model="resetpasswordemail"
                          :rules="mandatoryRules"
                          label="Email Address"
                          name="email"
                          prepend-icon="email"
                          type="text"
                          color="blue accent-3"
                        />
                      </v-form>
                    </v-card-text>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="ukpl-reset-password-card"
                  >
                    <div class="text-center mb-3 mt-12">
                      <v-btn
                        rounded
                        color="blue accent-3"
                        dark
                        @click="sendresetpassword()"
                      >
                        Reset Password
                      </v-btn>
                    </div>
                    <div class="text-center mb-3 mb-8">
                      <v-btn
                        rounded
                        color="blue accent-3"
                        dark
                        @click="step = 1"
                      >
                        Cancel
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>


import UkplMenu from '@/components/UkplMenu.vue';
import User from "../model/user";
import authservice from "../services/auth.service";
import UserService from "../services/user.service";

export default {
  name: "Home",
  components: {
    UkplMenu
  },
  props: {
    source: {
      type: [String, Object],
      default: ''
    }
  },
  data: () => ({
    resetpassword: "",
    resetpasswordemail: "",
    loginfail: false,
    registersuccess: false,
    registerfail: false,
    registerfailmessage: "",
    loginuser: new User("", "", "", "", ""),
    registeruser: new User("", "", "", "", ""),
    step: 1,
    password: "",
    registerpassword: "",
    confirmpassword: "",
    emailRules: [],
    mandatoryRules: [],
    rules: {
      required: (value) => !!value || "Field is Required.",
      min: (v) => v.length >= 8 || "Must be at least 8 characters",
      emailMatch: (v) => /.+@.+/.test(v) || "E-mail must be valid",
      nospace: (v) => /^\S*$/.test(v) || "Username cannot contain spaces",
    },
    signinvalid: true,
    registervalid: true,
    currentUser: null,
    isAdmin: false,
  }),
  computed: {
    passwordConfirmationRule() {
      return (
        this.registeruser.password === this.confirmpassword ||
        "Password must match"
      );
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  watch: {
    registersuccess: function () {
      if (this.registersuccess === false) {
        this.step = 1;
      }
    },
  },
  created() {
    // No redirect; always show login screen at '/'.
  },
  mounted: function () {
    this.nameRules = [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ];
    this.mandatoryRules = [(v) => !!v || "Field is required"];
    this.emailRules = [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ];
  },
  methods: {
    logOut() {
      // Dummy logout for now
      this.currentUser = null;
      this.isAdmin = false;
      this.$store.dispatch("auth/logout");
      this.$router.push("/");
    },
    sendresetpassword() {
      authservice.resetPassword(this.resetpasswordemail);
      this.step = 1;
    },
    signin() {
      this.loginfail = false;
      if (!this.$refs.signinform.validate()) {
        return false;
      }
      if (this.loginuser.username && this.loginuser.password) {
        this.$store.dispatch("auth/login", this.loginuser).then(
          (user) => {
            // user is the response from AuthService.login
            this.currentUser = user;
            // ...existing code...
            UserService.getUserDetails().then(
              (response) => {
                // ...existing code...
                if (
                  response.data.roles &&
                  response.data.roles.some(role => role.name === "ROLE_ADMIN")
                ) {
                  this.isAdmin = true;
                  this.currentUser = response.data;
                  this.$router.push("/players").catch(() => { });
                } else {
                  this.isAdmin = false;
                  this.loginfail = true;
                  this.message = "Access denied: Admins only.";
                  this.$store.dispatch("auth/logout");
                }
              },
              (error) => {
                this.message =
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  error.message ||
                  error.toString();
                this.loading = false;
                this.loginfail = true;
              }
            );
          },
          (error) => {
            this.loading = false;
            this.message =
              (error.response && error.response.data && error.response.data.message) ||
              error.message ||
              error.toString();
            this.loginfail = true;
          }
        );
      }
    },
    isUserDataPopulated(data) {
      if (
        this.isPopulated(data.username) &&
        this.isPopulated(data.firstname) &&
        this.isPopulated(data.lastname) &&
        this.isPopulated(data.gender) &&
        data.isOver18 !== null && data.isOver18 !== undefined &&
        this.isPopulated(data.contactNumber) &&
        this.isPopulated(data.addressline1) &&
        this.isPopulated(data.town) &&
        this.isPopulated(data.postcode) &&
        this.isPopulated(data.ukpsf) &&
        this.isPopulated(data.file)
      ) {
        return true;
      } else {
        return false;
      }

    },
    isPopulated(userfield) {
      if (
        typeof userfield !== "undefined" &&
        userfield !== "" &&
        userfield != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    // Registration method removed
  },
};
</script>
